import Model from "../Model";

export default class extends Model {
    async loadTable(page, limit, search = '') {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                search
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: 0,
        };

        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(line => {
                let telem = {
                    tbody: {}
                };
                telem.id = line.id;
                telem.tbody.name = line.name;
                telem.tbody.city = line.city;
                telem.tbody.color = line.color;
                result.tbody.push(telem);
            });

            result.pages = response.pages;
        }
        return result;
    }
}
